const KEY = "gerama.device-id";

/**
 * An anonymous, random per-browser id (`X-Device-Id`): it lets the home feed's
 * "made for you" row learn from what a visitor plays before they sign up. Kept
 * in localStorage; when that is unavailable (private mode, blocked storage) the
 * request simply goes without one and the row shows what is trending.
 */
export function getDeviceId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = window.crypto.randomUUID();
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return undefined;
  }
}
